import "antd/es/divider/style";
import _Divider from "antd/es/divider";
import "antd/es/col/style";
import _Col from "antd/es/col";
import "antd/es/row/style";
import _Row from "antd/es/row";
import "antd/es/radio/style";
import _Radio from "antd/es/radio";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Typography from '../typography';
import { useEffect } from 'react';

var CreateRadioBoxFilter = function CreateRadioBoxFilter(props) {
  var optionKey = props.optionKey,
      title = props.title,
      configList = props.configList,
      disabled = props.disabled,
      handleOptionsChange = props.handleOptionsChange,
      setConfirmValue = props.setConfirmValue,
      chooseed = props.chooseed,
      _onChange = props.onChange;
  useEffect(function () {
    if (disabled === null || disabled === void 0 ? void 0 : disabled.includes(chooseed)) {
      typeof _onChange === 'function' && _onChange(undefined);
      handleOptionsChange({
        type: optionKey,
        value: undefined
      });
      setConfirmValue(function (old) {
        return _objectSpread(_objectSpread({}, old), {}, _defineProperty({}, optionKey, undefined));
      });
    }
  }, [disabled]);
  return _jsxs("div", {
    className: "igloo-form-filter-drop-down-container-content-group",
    children: [_jsx("div", {
      className: "igloo-form-filter-drop-down-container-content-group-title",
      children: _jsx(Typography, {
        level: "h4",
        children: title
      })
    }), _jsx(_Radio.Group, {
      value: (disabled === null || disabled === void 0 ? void 0 : disabled.includes(chooseed)) ? undefined : chooseed,
      onChange: function onChange(e) {
        typeof _onChange === 'function' && _onChange(e.target.value);
        handleOptionsChange({
          type: optionKey,
          value: e.target.value
        });
      },
      children: _jsx(_Row, {
        gutter: [24, 16],
        children: configList.map(function (item) {
          return _jsx(_Col, {
            span: item.span || 8,
            children: _jsx(_Radio, {
              value: item.value,
              disabled: disabled === null || disabled === void 0 ? void 0 : disabled.includes(item.value),
              children: _jsx(Typography, {
                level: "body1",
                children: item.label
              })
            })
          }, item.value);
        })
      })
    }), _jsx(_Divider, {
      style: {
        margin: '16px 0px'
      }
    })]
  }, optionKey);
};

export default CreateRadioBoxFilter;